import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { AuthStatusCode, ErrorMessage } from '@as-react/common-types';
import { Box } from '@as/cotopaxi';
import { getBoxPropsFromAEMPaddings } from '../util/AEMUtil';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
import { REGISTRATION_EMAIL } from '../constants/StorageKeysConstants';
import { LoginRegistrationForm } from '../components/account/registration/LoginRegistrationForm';
import SessionStorageUtil from '../util/SessionStorageUtil';
const RegistrationCompactContainer = ({ paddings, title, image, registrationRedirectUrl, }) => {
    const { t } = useTranslation([I18N_NAMESPACES.account, I18N_NAMESPACES.buy]);
    const handleLoginRegistrationSuccess = (email) => {
        SessionStorageUtil.setItem(REGISTRATION_EMAIL, email);
        window.location.href = registrationRedirectUrl;
    };
    return (_jsx(Box, Object.assign({}, getBoxPropsFromAEMPaddings(paddings), { children: _jsx(LoginRegistrationForm, { sectionTitle: title, image: image, onSuccess: handleLoginRegistrationSuccess, emailValidationErrorMessages: {
                invalidEmail: t(ErrorMessage.INVALID_EMAIL),
                [AuthStatusCode.VALID_ACCOUNT]: t(ErrorMessage.REGISTRATION_COMPACT_USER_KNOWN),
                [AuthStatusCode.INVALID_ACCOUNT]: t(ErrorMessage.CHECKOUT_REGISTRATION_USER_KNOWN_SAME_FASCIA_NO_PASSWORD),
                [AuthStatusCode.VALID_ACCOUNT_OTHER_FASCIA]: t(ErrorMessage.CHECKOUT_REGISTRATION_USER_KNOWN_OTHER_FASCIA),
                [AuthStatusCode.INVALID_ACCOUNT_OTHER_FASCIA]: t(ErrorMessage.CHECKOUT_REGISTRATION_USER_KNOWN_OTHER_FASCIA_NO_PASSWORD),
            } }) })));
};
export default RegistrationCompactContainer;
